export default "__VITE_ASSET__B4Zhm6bp__"